<template>
  <nav class="breadcrumb-menu"
       :class="classes">
    <ul class="breadcrumb-menu__list">
      <li v-for="(item, index) in items"
          :key="index"
          class="breadcrumb-menu__item">
        <a :href="item.href"
           class="breadcrumb-menu__link">
          {{ item.text }}
        </a>
      </li>
    </ul>

    <a :href="parentItem.href"
       class="breadcrumb-menu__arrow">
      Back to {{ parentItem.text }}
    </a>
  </nav>
</template>

<script>
export default {
  name: "BreadcrumbMenu",
  props: {
    items: {
      type: Array,
      default: () => [
        {
          text: "Home",
          href: "/",
        },
      ],
    },
  },
  data: () => ( {
    navOpen: false,
  } ),
  computed: {
    rotation () {
      let result;

      if ( this.navOpen ) {
        result = 180;
      }

      return result;
    },
    parentItem () {
      let result = {};

      if ( this.items ) {
        ( [result] = this.items.slice( -2 ) );
      }

      return result;
    },
    lastItem () {
      let result = {};

      if ( this.items ) {
        ( [result] = this.items.slice( -1 ) );
      }

      return result;
    },
    classes () {
      const result = [];

      if ( this.navOpen ) {
        result.push( "breadcrumb-menu--open" );
      }

      return result;
    },
  },
  methods: {
    toggleNav () {
      this.navOpen = !this.navOpen;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.breadcrumb-menu {
  padding: 0;
  font-size: 0.9rem;

  &__list {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    transition: max-height 0.2s;

    @media ( max-width: 991px ) {
      visibility: hidden;
      display: none;
    }

    li:last-child {
      .breadcrumb-menu__link {
        color: @blue;
      }
    }

  }

  &__item {
    display: flex;
    align-items: center;
    color: @color-accent-1;
    transition: background-color 0.2s;

    &::after {
      content: ">";
      font-weight: 900;
      display: block;
      font-family: monospace;
      font-size: 18px;
      color: @blue;

      @media ( max-width: 991px ) {
        content: none;
      }
    }
  }

  &__item:last-child {
    &::after {
      display: none;
    }
  }

  &__link {
    display: block;
    padding: 10px;
    color: @dark-blue;
    text-decoration: none;
  }

  &__item:first-child &__link {
    padding-left: 0;
  }

  &__arrow {
    position: relative;
    display: inline-block;
    margin-top: 15px;
    background: #F6F6F6;
    padding: 10px 15px;
    text-decoration: none;
    color: @blue;
    font-weight: 600;
    transition: background-color 0.2s, color 0.2s;

    &::before {
      content: "";
      display: block;
      position: absolute;
      right: 100%;
      top: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 20px 15px 20px 0;
      border-color: transparent #F6F6F6 transparent transparent;
      transition: border-color 0.2s;
    }

    &:hover {
      background: desaturate( darken( #F6F6F6, 7.5% ), 7.5% );
      color: darken( #007d84, 7.5% );

      &::before {
        border-right-color: desaturate( darken( #F6F6F6, 7.5% ), 7.5% );
      }
    }

    @media ( min-width: 992px ) {
      display: none;
      visibility: hidden;
    }
  }
}
</style>
